import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  navbar: {
    height: "122px",
    width: "100%",
    background: "transparent",
    display: "flex",
    alignItems: "center",
    top: "0",
    zIndex: "999",
  },
  solidNavbar: {
    height: "122px",
    width: "100%",
    backgroundColor: "transparent",
    display: "flex",
    alignItems: "center",
    zIndex: "999",
  },
  contentText: {
    fontWeight: 700,
    fontSize: "14px",
    color: theme.agentTheme.card.link_foreground,
    textDecoration: "none",
    marginRight: "50px",
    cursor: "pointer",
    zIndex: "5",
    paddingLeft: "8px",
    "&:hover": {
      color: theme.agentTheme.primary.main,
    },
    [theme.breakpoints.down("md")]: {
      marginRight: "22px",
    },
  },
  contentTextDrop: {
    fontWeight: 500,
    fontSize: "16px",
    color: theme.agentTheme.card.foreground,
    cursor: "pointer",
    zIndex: "5",
    paddingLeft: "8px",
    "&:hover": {
      color: theme.agentTheme.secondary.main,
    },
  },
  dropdownText: {
    fontWeight: 400,
    fontSize: "14px",
    color: theme.agentTheme.card.link_foreground,
    height: "36px",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    zIndex: "5",
    paddingRight: "20px",
    paddingLeft: "8px",
  },
  contentStyledDot: {
    color: theme.agentTheme.primary.main,
    width: "4px",
    height: "4px",
    marginRight: "42px",
    borderRadius: "50%",
    transform: "translate(0, 50%)",
  },
  logoImg: {
    height: "70px",
    width: "auto",
    marginLeft: "30px",
    marginRight: "39px",
    cursor: "pointer",
  },
  menuBox: {
    display: "flex",
    flexDirection: "column",
    paddingTop: "9px",
    height: "505px",
    width: "400px",
  },
  menuLogo: {
    height: "40.3px",
    width: "auto",
  },
  menuItemHeading: {
    fontWeight: "400 !important",
    fontSize: "16px",
    color: theme.agentTheme.card.link_foreground,
  },
  menuItemText: {
    fontWeight: "400 !important",
    fontSize: "16px",
    color: theme.agentTheme.card.link_foreground,
    marginTop: "14px",
    marginBottom: "26px",
    lineHeight: "20px",
  },
  contactSupportIcon: {
    cursor: "pointer",
    marginRight: "30px",
    position: "absolute",
    right: "0",
    "&:hover": {
      color: theme.agentTheme.secondary.main,
    },
  },
  menuList: {
    "&:hover": {
      backgroundColor: theme.agentTheme.secondary.main,
      color: theme.agentTheme.card.link_foreground,
    },
  },
  primarytext:{
    color: `${theme.agentTheme.background.primary_text} !important`
  },
  usernameText: {
    fontSize: "14px",
    marginTop: "12px",
    color: theme.agentTheme.card.link_foreground,
    cursor: "pointer",
  },
}));

export default useStyles;
